import { Box } from '@mui/material'
import React from 'react'

type AccountSelectProps = {
  active?: boolean
  icon: React.ElementType
  label: string
  onClick: () => void
}

const AccountSelect = ({
  active,
  icon: Icon,
  label,
  onClick,
}: AccountSelectProps) => {
  return (
    <Box
      component="div"
      sx={{
        padding: '30px 40px',
        backgroundColor: active ? '#ffffff' : '#f3f3f3',
        color: active ? '#21384c' : '#9ca6ad',
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'center',
        gap: '10px',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#ffffff',
          color: '#21384c',
        },
      }}
      onClick={onClick}
    >
      <Icon sx={{ fontSize: '50px' }} />
      <Box
        component="span"
        sx={{
          fontSize: '20px',
        }}
      >
        {label}
      </Box>
    </Box>
  )
}

export default AccountSelect
